var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page"},[_c('page-header'),_c('div',{staticClass:"page-content"},[_c('page-banner'),_c('company-info')],1),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }